import { Typography, Link, Stack, Paper } from "@mui/material";

export function Copyright() {
  return (
    <Paper square variant="outlined" sx={{ padding: 2 }}>
      <Typography variant="body2" color="text.secondary" component="div">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={1}
        >
          <span>Copyright © 2021-{new Date().getFullYear()}</span>

          <Link color="inherit" href="https://www.cciahn.com" target="_blank">
            Cámara de Comercio e Industrias de Atlántida
          </Link>
        </Stack>
      </Typography>
    </Paper>
  );
}
